










import SfLoader from '/storefrontUI/components/components/atoms/SfLoader/SfLoader.vue';
import SfHeading from '/storefrontUI/components/components/atoms/SfHeading/SfHeading.vue';
import {
  defineComponent,
  ref,
  useFetch,
  useContext, computed, useRoute, onMounted,
} from '@nuxtjs/composition-api';
import { useCache, CacheTagPrefix } from '@vue-storefront/cache';
import { getMetaInfo } from '~/helpers/getMetaInfo';
import { useContent, useConfig } from '~/composables';
import type { CmsPage } from '~/modules/GraphQL/types';
import { usePageStore } from '~/stores/page';
import HTMLContent from '~/components/HTMLContent.vue';

export default defineComponent({
  name: 'CmsPage',
  components: {
    HTMLContent,
    SfLoader,
    SfHeading,
  },
  setup() {
    const route = useRoute();
    const { routeData } = usePageStore();
    const { addTags } = useCache();
    const { error: nuxtError } = useContext();
    const {
      loadPage,
      loading,
      error,
    } = useContent();
    const { config } = useConfig();

    const page = ref<CmsPage | null>(null);

    const url = route.value.fullPath;

    const logoSrc = computed(() => {
      const baseMediaUrl = config.value.base_media_url;
      const logo = config.value.header_logo_src;

      return baseMediaUrl && logo ? `${baseMediaUrl}logo/${logo}` : '';
    });

    useFetch(async () => {
      page.value = await loadPage({ identifier: routeData.identifier });

      if (error?.value?.page || !page.value) nuxtError({ statusCode: 404 });

      addTags([{ prefix: CacheTagPrefix.View, value: routeData.identifier }]);
    });

    onMounted(async () => {
      if(url == '/it/newsletter' || url == '/en/newsletter'){
        let sibScript = document.createElement('script')
        sibScript.setAttribute('src', 'https://sibforms.com/forms/end-form/build/main.js')
        document.head.appendChild(sibScript)
      }

    });
    return {
      page,
      logoSrc,
      url,
      loading,
    };
  },
  head() {
    return getMetaInfo(this.page, false, this.logoSrc, 'https://www.needstore.it' + this.url);
  },
});
